import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { csrfToken } from '@/util/helpers/ajax-helpers';

export const GET_DRILLDOWN_DATA_TABLE = 'getDrillDownDataTable';
export const drilldownApi = createApi({
  reducerPath: 'drilldownApi',
  baseQuery: fetchBaseQuery({
    baseUrl: '/',
    credentials: 'same-origin',
    prepareHeaders: (headers) => {
      headers.set('Content-Type', 'application/json;charset=UTF-8');
      headers.set('x-requested-with', 'XMLHttpRequest');

      const token = csrfToken();
      if (token) headers.set('x-csrf-token', token);

      return headers;
    },
  }),
  endpoints: (builder) => ({
    // TODO: should be GET query
    [GET_DRILLDOWN_DATA_TABLE]: builder.mutation({
      query: ({ datasourceId, body }) => ({
        url: `datasources/${datasourceId}/drilldown`,
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const { useGetDrillDownDataTableMutation } = drilldownApi;
